export function cookiesInit() {
  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) return value;
    }
    return null;
  }

  const cookiesContainer = document.querySelector('.cookies');
  if (!cookiesContainer) return;

  if (getCookie('confirmCookie')) {
    cookiesContainer.remove();
    return;
  }

  cookiesContainer.classList.add('visible')

  const cookiesBtn = document.getElementById('cookiesBtn');
  const checkbox = document.querySelector('.cookies__input');

  if (!cookiesBtn || !checkbox) return;

  checkbox.addEventListener('change', () => {
    cookiesBtn.disabled = !checkbox.checked;
  });

  cookiesBtn.onclick = () => {
    cookiesContainer.classList.add('hidden');

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 7);
    const expires = currentDate.toUTCString();

    document.cookie = 'confirmCookie=true; expires=' + expires + '; path=/';

    setTimeout(() => {
      cookiesContainer.remove();
    }, 300);
  };
}
